import { render, staticRenderFns } from "./SingleRound.vue?vue&type=template&id=11e396d0&scoped=true&"
import script from "./SingleRound.vue?vue&type=script&lang=js&"
export * from "./SingleRound.vue?vue&type=script&lang=js&"
import style0 from "./SingleRound.vue?vue&type=style&index=0&id=11e396d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e396d0",
  null
  
)

export default component.exports